import React, { useState, useEffect } from 'react';  
import { Button, message, Avatar, Space, Typography, Spin } from 'antd';  
import { UploadOutlined } from '@ant-design/icons';  
import { uploadProfilePhoto, fetchProfilePhoto } from '../../api/user';  
  
const { Title } = Typography;  
  
const PhotoUpload = ({  
  onNext,  
  submitting,  
  onPhotoUploaded,  
  contestant,  
  setContestant,  
}) => {  
  const [uploading, setUploading] = useState(false);  
  const [photoUrl, setPhotoUrl] = useState(null);  
  
  // Fetch profile photo for this contestant  
  useEffect(() => {  
    if (!contestant) return;  
    const fetchPic = async () => {  
      try {  
        const url = await fetchProfilePhoto(contestant._id); // expects id  
        setPhotoUrl(url);  
        setContestant && setContestant((prev) => ({ ...prev, profilePhotoUrl: url }));  
      } catch (e) {  
        setPhotoUrl(null);  
      }  
    };  
    fetchPic();  
  }, [contestant, setContestant]);  
  
  const handleFileChange = async (e) => {  
    const file = e.target.files[0];  
    if (!file) return;  
    if (!contestant) {  
      message.error('No contestant');  
      return;  
    }  
    setUploading(true);  
    try {  
      await uploadProfilePhoto(contestant._id, file);  
      message.success('Profile photo uploaded successfully');  
      // Fetch & update new photo  
      const url = await fetchProfilePhoto(contestant._id);  
      setPhotoUrl(url);  
      setContestant && setContestant((prev) => ({ ...prev, profilePhotoUrl: url }));  
      onPhotoUploaded && onPhotoUploaded(true);  
    } catch (error) {  
      message.error(error.message || 'Error uploading photo');  
    } finally {  
      setUploading(false);  
      // Reset input value so you can upload the same file again if needed  
      e.target.value = '';  
    }  
  };  
  
  return (  
    <div className="photo-upload-page">  
      <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>  
        <Title level={4}>Upload Profile Picture</Title>  
        <Spin spinning={uploading}>  
          <Avatar  
            size={100}  
            style={{ backgroundColor: '#1271dd', fontSize: 40, marginBottom: '16px' }}  
            src={photoUrl}  
          />  
        </Spin>  
        <div>  
          <input  
            type="file"  
            id="profilePhotoInput"  
            style={{ display: 'none' }}  
            onChange={handleFileChange}  
            accept=".jpg,.jpeg"  
            disabled={uploading}  
          />  
          <label htmlFor="profilePhotoInput">  
            <Button  
              icon={<UploadOutlined />}  
              onClick={() => document.getElementById('profilePhotoInput').click()}  
              disabled={uploading}  
            >  
              Change Profile Picture  
            </Button>  
          </label>  
        </div>  
      </Space>  
    </div>  
  );  
};  
  
export default PhotoUpload;  